import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const Product = () => {
    return (
        <WrapperLayout>
            <Main />
        </WrapperLayout>
    )
}
export default Product